export default __webpack_public_path__ + "static/media/avatar_siti5.6cbf548a.mp3";